import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../hooks/useAuthStore";
import { getTabScope, getTabToken } from "../stores/auth.store";

export default function PublicRoute({
  children,
  authenticatedPath = "/user/travel-assistant",
}) {
  const location = useLocation();
  const { role } = useAuthStore();

  // Only this tab's session counts. Another tab being signed in must not stop
  // this one reaching the login page to sign in as a different role.
  const hasTabSession = Boolean(getTabToken());

  const getDashboardPath = () => {
    if (role === "admin" || role === "super_admin") return "/admin";
    if (role === "assistant" || role === "serviceProvider") return "/dashboards/assistant/overview";
    if (role === "user") return authenticatedPath;

    const scope = getTabScope();
    if (scope === "assistant") return "/dashboards/assistant/overview";
    if (scope === "admin") return "/admin";
    return authenticatedPath;
  };

  // A session held only in memory, with its stored token gone, was ended from
  // another tab — show the login page rather than bounce off a dashboard guard.
  if (hasTabSession) {
    return (
      <Navigate
        to={getDashboardPath()}
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}
